export const bracketRegex = /\[.+\]\..+$/
